import { useQuery } from "@tanstack/react-query";
import { getExpenseById } from "../services";

export const useGetExpenseById = (id: string) =>
	useQuery({
		queryKey: ["expense", id],
		queryFn: () => getExpenseById(id),
		enabled: !!id,
	});
